/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Enter_EmailInputs */

const en_mobile_enter_email = /** @type {(inputs: Mobile_Enter_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your email`)
};

const es_mobile_enter_email = /** @type {(inputs: Mobile_Enter_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresa tu correo`)
};

/**
* | output |
* | --- |
* | "Enter your email" |
*
* @param {Mobile_Enter_EmailInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_enter_email = /** @type {((inputs?: Mobile_Enter_EmailInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Enter_EmailInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_enter_email(inputs)
	return en_mobile_enter_email(inputs)
});